export default "__VITE_ASSET__d2926582__"